'use client'

import Button from '@/components/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/sharp-solid-svg-icons'
import classNames from 'classnames'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import { useEffect, useState, useSyncExternalStore } from 'react'
import styles from './AnimatedHero.module.scss'

const Player = dynamic(() => import('@lottiefiles/react-lottie-player').then((mod) => mod.Player), {
  ssr: false,
  loading: () => <div className={styles.player} aria-hidden="true" />
})

function subscribeToResize(callback) {
  window.addEventListener('resize', callback)
  return () => window.removeEventListener('resize', callback)
}

const MOBILE_BREAKPOINT = 767
const TABLET_BREAKPOINT = 1024

const getWidth = () => window.innerWidth

const AnimatedHero = () => {
  const width = useSyncExternalStore(subscribeToResize, getWidth, () => null)
  const isMobile = width !== null && width <= MOBILE_BREAKPOINT
  const animationSrc = width !== null && width <= TABLET_BREAKPOINT ? '/IntegrityHeroAnimationSm.json' : '/IntegrityHeroAnimation.json'
  const [playerKey, setPlayerKey] = useState(0)

  // Fix: Remount Lottie Player on visibilitychange (iOS Safari background bug)
  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        setPlayerKey((k) => k + 1)
      }
    }
    document.addEventListener('visibilitychange', handleVisibility)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibility)
    }
  }, [])

  return (
    <div className={styles.mainHero} data-cy="hero-section">
      <Head>
        <link rel="preload" href="/dark-background.webp" as="image" type="image/webp" fetchPriority="high" />
        <link rel="preload" href="/IntegrityHeroAnimation.json" as="fetch" crossOrigin="anonymous" media="(min-width: 1025px)" />
        <link
          rel="preload"
          href="/IntegrityHeroAnimationSm.json"
          as="fetch"
          crossOrigin="anonymous"
          media="(min-width: 768px) and (max-width: 1024px)"
        />
      </Head>
      {!isMobile && <Player key={playerKey} className={styles.player} autoplay keepLastFrame speed={0.6} src={animationSrc} />}

      <div className={styles.container}>
        <h1 className={styles.mobileText}>
          <span className={styles.orange}>We</span> design, develop, <span className={styles.orange}>and</span> deliver{' '}
          <span className={styles.orange}>world&#8209;class experiences.</span>
        </h1>

        <p className={styles.bigP}>
          Leading web consulting firm delivering omnichannel marketing, UX/UI design, media, experiential/events, and technology solutions
          to clients globally for over 25 years.
        </p>
        <div className={styles.buttonContainer}>
          <Button href="/contact" className={styles.button}>
            ASK US HOW <FontAwesomeIcon icon={faArrowRight} />
          </Button>
          <Button href="/work" className={classNames(styles.button, styles.secondaryButton)}>
            SEE OUR WORK <FontAwesomeIcon icon={faArrowRight} />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default AnimatedHero
